import { TotpSetup } from "#/feature/auth/totp-setup";
import { useNavigate } from "react-router-dom";

import { containerStyles, contentStyles, titleStyles } from "./login.css";

export function TotpSetupPage() {
  const navigate = useNavigate();

  return (
    <div className={containerStyles}>
      <div className={contentStyles}>
        <h1 className={titleStyles}>Set up authenticator</h1>
        <p style={{ fontSize: "0.875rem", textAlign: "center", marginBottom: "1rem" }}>
          Optional — enables password recovery via your authenticator app.
        </p>
        <TotpSetup
          mode="add"
          onComplete={() => navigate("/")}
          onCancel={() => navigate("/")}
        />
      </div>
    </div>
  );
}
